import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { realtyGetObjects, selectObjectsList } from "../../redux/modules/realty";
import Layout from "../layout"
import Table from "../common/table"
import Filter from './filter';

const Realty = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [visible, setVisible] = useState(true);
  const [active, setActive] = useState(location.state ? decodeURI(location.state.hash) : (window.location.hash ? decodeURI(window.location.hash.split('#')[1]) : "Жилая недвижимость"));

  const [fields, setValue] = useState({
    project: {
      value:''
    },
    location: {
      value:''
    },
    rooms: {
      value: []
    },
    deadline: {
      value:''
    },
    cost: {
      value:''
    },
    price: {
      value:''
    },
    square: {
      value:''
    },
    floor: {
      value:''
    },
    part: {
      value:''
    },
    advantages: {
      value:''
    },
    decoration: {
      value:''
    },
    views: {
      value:''
    },
    type: {
      value:''
    },
  });  
  const [items, setItems] = useState(null);

  const auth = useSelector(state => state.auth);
  const objects = useSelector(state => state.realty.objects);
  const mobile = useSelector(state => state.mobile);

  const result = useSelector(state => selectObjectsList(state));

  useEffect(() => {    
    document.title = 'Выбор недвижимости | Личный кабинет Брокера THE FIVE';
    
  }, []);
  
  useEffect(() => {    
    
    if(!objects) {
      dispatch(
        realtyGetObjects({
          cmd: 'orders-list',
          _debug_token: auth.token
        })
      )
    }

  }, []);

  const handleFilterClick = () => {
    setVisible(!visible);
    document.querySelector('.tabs-content').scrollTo(0, 0) 
  };
  
  const handleClick = (status) => {
    setActive(status);
    navigate('#' + status);
  };

  const countItemsByStatus = (data, status) => {
    if (!data) return 0;
    return data.filter((item) => item.type === status).length;
  };

  const counts = {
    all: result ? result.length : 0,
    scheduled: countItemsByStatus(result, 'Жилая недвижимость'),
    finish: countItemsByStatus(result, 'Коммерческая недвижимость'),
    cancel: countItemsByStatus(result, 'Машиноместа'),
    cancel: countItemsByStatus(result, 'Кладовые'),
  };

  const filteredResult = items ? items.filter((item) => item.type === active) : result ? result.filter((item) => item.type === active) : [];

  console.log(result)
  console.log(filteredResult)

  return (
    <Layout>
      <div className="page-realty">
        <div className="tabs">
          <div className="tabs__wrap">
            <div className="tabs__item" onClick={() => handleClick("Жилая недвижимость")} data-active={active === "Жилая недвижимость"} id={"Жилая недвижимость"}>
              Жилая недвижимость 
            </div>
            <div className="tabs__item" onClick={() => handleClick('Коммерческая недвижимость')} data-active={active === 'Коммерческая недвижимость'} id={'Коммерческая недвижимость'}>
              Коммерческая недвижимость
            </div>
            <div className="tabs__item" onClick={(e) => handleClick('Машиноместа')} data-active={active === 'Машиноместа'} id={'Машиноместа'}>
              Машиноместа
            </div>
            <div className="tabs__item" onClick={(e) => handleClick('Кладовые')} data-active={active === 'Кладовые'} id={'Кладовые'}>              
              Кладовые
            </div>
          </div>
          {!visible && <div className="filter-btn" onClick={handleFilterClick}></div>}
        </div>
      
        <div className="tabs-content">          
          <Filter fields={fields} setValue={setValue} alldata={result} setItems={setItems} data={filteredResult} />
          <Table 
            columns={mobile ? ([
                { label: "Дата и время", value: "timeslot" },
                { label: "Клиент", value: "clientName" },
                { label: "", value: "action" },
                { label: "Телефон", value: "clientPhone" },
                { label: "Проект/Тип объекта", value: "project" },
                { label: "Менеджер", value: "manager" },
                { label: "Статус", value: "status" },
                { label: "Формат встречи", value: "formatId" },
                { label: "Брокер", value: "brocker" },
              ]
            ) : (
              [
                { label: "Проект", value: "project" },
                { label: "Корпус", value: "building" },
                { label: "Номер", value: "number" },
                { label: "Этаж", value: "floor" },
                { label: "Комнат", value: "rooms" },
                { label: "Площадь", value: "area" },
                { label: "Стоимость", value: "totalCost" },
                { label: "Цена за м²", value: "price" },
                { label: "Отделка", value: "decoration" },
                { label: "Планировка", value: "planPictureUrl" },
                { label: "", value: "present" },
              ]
            )}
            sortmobile={[
              { label: "Дата/время", value: "dateTime" },
              { label: "Клиент", value: "clientName" },
            ]}
            data={filteredResult}
            realty={true}
          /> 
        </div>
      </div>      
    </Layout>
  )
}

export default Realty